import { createFileRoute, Outlet } from "@tanstack/react-router";

import React from "react";
import { useTranslation } from "react-i18next";
import TabLayout from "src/components/base/tab-layout";
import DEVICE_CONTEXT, { DeviceProvider } from "src/context/customer/device";
import { BackButton } from "src/components/base/button";
import { Tab, TabMenu } from "src/components/base/tab-menu";

/**
 * The properties for {@link DeviceTabs}
 */
export type DeviceTabsProps = {};

/**
 * Tabs for the device view
 */
function DeviceTabs(props: DeviceTabsProps) {
    const [t] = useTranslation("customer-device-view");

    const { deviceId } = Route.useParams();

    return (
        <DeviceProvider uuid={deviceId}>
            <DEVICE_CONTEXT.Consumer>
                {(deviceContext) => (
                    <div className={"flex flex-col gap-6"}>
                        <BackButton className={"self-start"} href={"/c/devices"}>
                            {t("button.back-to-device-overview")}
                        </BackButton>

                        <TabLayout
                            heading={t("heading.device-view", { device: deviceContext.device.dnsname })}
                            tabs={
                                <TabMenu>
                                    <Tab href={"/c/devices/$deviceId/general"} params={{ deviceId: deviceId }}>
                                        {t("heading.general")}
                                    </Tab>
                                    <Tab href={"/c/devices/$deviceId/inbound-acls"} params={{ deviceId: deviceId }}>
                                        {t("heading.inbound-acl")}
                                    </Tab>
                                    <Tab href={"/c/devices/$deviceId/outbound-acls"} params={{ deviceId: deviceId }}>
                                        {t("heading.outbound-acl")}
                                    </Tab>
                                </TabMenu>
                            }
                        >
                            <Outlet />
                        </TabLayout>
                    </div>
                )}
            </DEVICE_CONTEXT.Consumer>
        </DeviceProvider>
    );
}

export const Route = createFileRoute("/_customer/c/devices/$deviceId/_device")({
    component: DeviceTabs,
});
